// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.light-table-striped:nth-child(odd) {
  background-color: rgba(238, 238, 238, 0.493);
  border-bottom: 1px solid black;
}
.light-table-striped,
.light-table-head {
  border-bottom: 1px solid black;
}
.dark-table-striped:nth-child(odd) {
  background-color: rgb(255 255 255 / 10%);
}
.dark-table-striped,
.dark-table-head {
  border-bottom: 1px solid rgb(255, 255, 255);
}
.table .light-table-striped {
  border: 1px solid black;
}
.table .dark-table-striped {
  border: 1px solid rgb(255, 255, 255);
}
`, "",{"version":3,"sources":["webpack://./src/examples/Tables/DataTable/tableStyle.css"],"names":[],"mappings":"AAAA;EACE,4CAA4C;EAC5C,8BAA8B;AAChC;AACA;;EAEE,8BAA8B;AAChC;AACA;EACE,wCAAwC;AAC1C;AACA;;EAEE,2CAA2C;AAC7C;AACA;EACE,uBAAuB;AACzB;AACA;EACE,oCAAoC;AACtC","sourcesContent":[".light-table-striped:nth-child(odd) {\n  background-color: rgba(238, 238, 238, 0.493);\n  border-bottom: 1px solid black;\n}\n.light-table-striped,\n.light-table-head {\n  border-bottom: 1px solid black;\n}\n.dark-table-striped:nth-child(odd) {\n  background-color: rgb(255 255 255 / 10%);\n}\n.dark-table-striped,\n.dark-table-head {\n  border-bottom: 1px solid rgb(255, 255, 255);\n}\n.table .light-table-striped {\n  border: 1px solid black;\n}\n.table .dark-table-striped {\n  border: 1px solid rgb(255, 255, 255);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
